var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack gap-5 h-stretch"},[_c('div',{staticClass:"pane-left gap-3"},[_c('div',{staticClass:"h-stack gap-3"},[_c('label',{staticStyle:{"width":"40px"}},[_vm._v("Client")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedClient),expression:"selectedClient"}],staticClass:"fixed",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedClient=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._l((_vm.clients),function(client){return _c('option',{key:client._id,domProps:{"value":client._id}},[_vm._v(" "+_vm._s(client.name)+" ")])})],2)]),_c('div',{staticClass:"pane-right gap-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"text","placeholder":"Type to search..."},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing)return;_vm.search=$event.target.value}}}),_c('button',{staticClass:"add",on:{"click":function($event){return _vm.$router.push('/projects/add')}}},[_vm._v("New")])])]),_c('div',{staticClass:"h-stack gap-3 h-start"},_vm._l((_vm.states),function(state){return _c('div',{key:state.name,staticClass:"h-stack gap-3"},[_c('label',[_vm._v(_vm._s(state.name.charAt(0).toUpperCase() + state.name.slice(1))+":")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(state.value),expression:"state.value"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(state.value)?_vm._i(state.value,null)>-1:(state.value)},on:{"change":[function($event){var $$a=state.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(state, "value", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(state, "value", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(state, "value", $$c)}},function($event){return _vm.onClientSelected()}]}})])}),0),_c('Table',{attrs:{"loading":_vm.loading,"items":_vm.projects,"defaultColumn":2,"defaultAscending":true,"href":'/projects/detail/',"css":"60px 60px 1fr 80px 80px 40px auto","limit":50,"pageable":true,"columns":[
      {
        name: 'State',
        sort: 'alphabet',
        path: ['state'],
      },
      {
        name: 'Icon',
        sort: 'alphabet',
        path: ['icon'],
      },
      {
        name: 'Project',
        sort: 'alphabet',
        path: ['name'],
      },
      {
        name: 'Created',
        sort: 'date',
        path: ['createdDate'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Deadline',
        sort: 'date',
        path: ['deadline'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Vimeo',
        sort: 'alphabet',
        path: ['links'],
        formatType: 'link',
        hideText: true,
        formatMap: (links) => (links.length > 0 ? links[0].url : null),
      },
      {
        name: 'Info',
        href: '/projects/pricelists/',
        appendId: true,
      },
    ]},scopedSlots:_vm._u([{key:"Info",fn:function({ item }){return [_c('div',{staticClass:"icon-square",class:_vm.getIconClass(item)},[_c('i',{staticClass:"fas fa-euro-sign"})])]}},{key:"Vimeo",fn:function({ item }){return [(item.links.length > 0)?_c('div',{staticClass:"icon-square"},[_c('i',{staticClass:"fas fa-link"})]):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }